import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ComparisonContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Noto Sans Thai', sans-serif !important;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: normal;
    color: #666666;
  }
`;

const MainHeader = styled.div`
  background: white;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Logo = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #666;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const ProfileImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

const NotificationContainer = styled.div`
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
  margin-right: 8px;

  &:hover {
    transform: scale(1.1);
  }
`;

const BellIcon = styled.div`
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' fill='%23666666'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

const NotificationBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: #ff4444;
  color: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans Thai', sans-serif !important;
  min-width: 16px;
  padding: 0 2px;
`;

const ProfileName = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #666;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const TabContainer = styled.div`
  display: flex;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e1e5e9;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
`;

const Tab = styled.div`
  padding: 12px 5px;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  color: ${props => props.active ? 'white' : '#B0B0B0'};
  background-color: ${props => props.active ? '#00BBD3' : '#F2F2F2'};
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Noto Sans Thai', sans-serif !important;
  line-height: 1.2;
  white-space: nowrap;
  
  ${props => {
    if (props.children === 'สุขภาพของคุณ') {
      return `width: 152px;`;
    } else if (props.children === 'ผลตรวจรวม') {
      return `width: 120px;`;
    } else if (props.children === 'ผลตรวจเปรียบเทียบ') {
      return `width: 168px;`;
    }
    return '';
  }}
  
  &:hover {
    background-color: ${props => props.active ? '#00BBD3' : '#e9ecef'};
  }
`;

const Content = styled.div`
  padding: 24px;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const ComparisonTable = styled.div`
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
  min-width: 100%;
`;

const TableHeader = styled.div`
  background-color: #00BBD3;
  color: white;
`;

const HeaderRow1 = styled.div`
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(160px, 1.6fr);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  min-width: 320px;
`;

const HeaderRow2 = styled.div`
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(80px, 0.8fr) minmax(80px, 0.8fr);
  min-width: 320px;
`;

const HeaderCell = styled.div`
  padding: 12px 16px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  font-family: 'Noto Sans Thai', sans-serif !important;
  color: white;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    text-align: left;
    justify-content: flex-start;
    padding-left: 20px;
  }

  @media (max-width: 480px) {
    padding: 12px 8px;
    font-size: 14px;
  }
`;

const EmptyHeaderCell = styled(HeaderCell)`
  border-right: 1px solid rgba(255, 255, 255, 0.2);
`;

const DateHeaderSpan = styled(HeaderCell)`
  background-color: #00BBD3;
`;

const DateCell = styled(HeaderCell)`
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  
  &:last-child {
    border-right: none;
  }
`;

const TableBody = styled.div`
  background-color: white;
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(80px, 0.8fr) minmax(80px, 0.8fr);
  border-bottom: 1px solid #f0f0f0;
  min-width: 320px;

  &:last-child {
    border-bottom: none;
  }
`;

const TableCell = styled.div`
  padding: 16px 12px;
  font-size: 16px;
  color: #333333;
  font-family: 'Noto Sans Thai', sans-serif !important;
  text-align: center;
  border-right: 2px solid #d0d0d0;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:last-child {
    border-right: none;
  }

  @media (max-width: 480px) {
    padding: 12px 8px;
    font-size: 16px;
  }
`;

const TestNameCell = styled(TableCell)`
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  justify-content: ${props => props.indent ? 'center' : 'flex-start'};
  text-align: ${props => props.indent ? 'center' : 'left'};
  padding-left: ${props => props.indent ? '24px' : '12px'};
  padding-right: 12px;
  color: #333333;
  border-bottom: ${props => props.noBottomBorder ? 'none' : '1px solid #f0f0f0'};
`;

const MergedCell = styled(TableCell)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 16px 12px;
  gap: 8px;
`;

const SubItemRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #666666;
`;

const SubItemName = styled.span`
  flex: 1;
  text-align: center;
  justify-self: center;
`;

const MergedValueCell = styled(TableCell)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 12px;
  gap: 8px;
`;

const SubValue = styled.div`
  font-size: 16px;
  color: #333333;
  min-height: 24px;
  display: flex;
  align-items: center;
`;

const ComparisonResultsPage = () => {
  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState(3);

  const handleNotificationClick = () => {
    navigate('/notifications');
  };
  const handleTabClick = (tab) => {
    if (tab === 'สุขภาพของคุณ') {
      window.location.href = '/dashboard';
    } else if (tab === 'ผลตรวจรวม') {
      window.location.href = '/test-results';
    }
  };

  const testData = [
    { name: 'ความดันโลหิต', value1: '180/80', value2: '180/80', bold: true },
    { name: 'น้ำตาลในเลือด', value1: '120', value2: '120', bold: true },
    {
      name: 'ไขมัน',
      subItems: [
        { name: 'คอเลสเตอรอลรวม', value1: '120', value2: '120' },
        { name: 'ไตรกลีเซอไรด์', value1: '167', value2: '167' }
      ],
      bold: true,
      merged: true
    },
    { name: 'ตับ', value1: '120', value2: '120', bold: true },
    { name: 'ไต', value1: '120', value2: '120', bold: true },
    { name: 'กรดยูริค', value1: '120', value2: '120', bold: true }
  ];

  return (
    <ComparisonContainer>
      <MainHeader>
        <HeaderLeft>
          <Logo src="./logo.png" alt="MFU Logo" />
          <HeaderTitle>MFU Wellness Center</HeaderTitle>
        </HeaderLeft>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <NotificationContainer onClick={handleNotificationClick}>
            <BellIcon />
            {notificationCount > 0 && (
              <NotificationBadge>{notificationCount}</NotificationBadge>
            )}
          </NotificationContainer>
          <ProfileContainer onClick={() => navigate('/profile-edit')}>
            <ProfileName>พงษ์ชัย</ProfileName>
            <ProfileImage src="./person.png" alt="Profile" />
          </ProfileContainer>
        </div>
      </MainHeader>

      <TabContainer>
        <Tab onClick={() => handleTabClick('สุขภาพของคุณ')}>สุขภาพของคุณ</Tab>
        <Tab onClick={() => handleTabClick('ผลตรวจรวม')}>ผลตรวจรวม</Tab>
        <Tab active>ผลตรวจเปรียบเทียบ</Tab>
      </TabContainer>

      <Content>
        <ComparisonTable>
          <TableHeader>
            <HeaderRow1>
              <EmptyHeaderCell></EmptyHeaderCell>
              <DateHeaderSpan>วันที่ตรวจ</DateHeaderSpan>
            </HeaderRow1>
            <HeaderRow2>
              <HeaderCell></HeaderCell>
              <DateCell>15/01/68</DateCell>
              <DateCell>12/11/67</DateCell>
            </HeaderRow2>
          </TableHeader>
          
          <TableBody>
            {testData.map((item, index) => (
              <TableRow key={index}>
                {item.merged ? (
                  <>
                    <MergedCell>
                      <div style={{ fontWeight: 'bold', marginBottom: '8px', textAlign: 'left', fontSize: '16px', color: '#333333' }}>{item.name}</div>
                      {item.subItems.map((subItem, subIndex) => (
                        <div key={subIndex} style={{ width: '100%', textAlign: 'left', paddingLeft: '24px', color: '#333333', fontSize: '16px' }}>
                          {subItem.name}
                        </div>
                      ))}
                    </MergedCell>
                    <MergedValueCell>
                      <div style={{ opacity: 0, minHeight: '24px' }}></div>
                      {item.subItems.map((subItem, subIndex) => (
                        <SubValue key={subIndex}>{subItem.value1}</SubValue>
                      ))}
                    </MergedValueCell>
                    <MergedValueCell>
                      <div style={{ opacity: 0, minHeight: '24px' }}></div>
                      {item.subItems.map((subItem, subIndex) => (
                        <SubValue key={subIndex}>{subItem.value2}</SubValue>
                      ))}
                    </MergedValueCell>
                  </>
                ) : (
                  <>
                    <TestNameCell bold={item.bold} indent={item.indent} noBottomBorder={item.noBottomBorder}>
                      {item.name}
                    </TestNameCell>
                    <TableCell style={{ borderBottom: item.noBottomBorder ? 'none' : '1px solid #f0f0f0' }}>{item.value1}</TableCell>
                    <TableCell style={{ borderBottom: item.noBottomBorder ? 'none' : '1px solid #f0f0f0' }}>{item.value2}</TableCell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </ComparisonTable>
      </Content>
    </ComparisonContainer>
  );
};

export default ComparisonResultsPage;